export interface Category {
  id: string;
  name: string;
}

export interface HotItem {
  rank: number;
  title: string;
  category: string;
  heat: number;
  tag: string;
  live: boolean;
}

export interface FeedItem {
  id: number;
  category: string;
  title: string;
  snippet: string;
  tags: string[];
  time: string;
  views: string;
  image: string;
  alt: string;
  featured?: boolean;
}

export interface ChainStage {
  stage: string;
  title: string;
  desc: string;
  time: string;
  state: string;
}

export interface Faq {
  q: string;
  a: string;
}

export interface FeatureCard {
  icon: string;
  title: string;
  desc: string;
}

export const categories: Category[] = [
  { id: "all", name: "全部前线" },
  { id: "variety", name: "综艺现场" },
  { id: "live", name: "直播名场面" },
  { id: "showbiz", name: "圈内动态" },
  { id: "meme", name: "网络热梗" },
  { id: "life", name: "生活奇闻" },
];

export const tickerItems: string[] = [
  "【实时】唱跳新综首期路透连出三组名场面，观众席实拍持续回刷",
  "【目击】雨夜剧组拍摄现场，场务小姐姐分发暖贴一幕登本日点赞榜",
  "【直播】百万粉测评博主烤炉翻车全程，临场补救细节成热议点",
  "【原发】反转一词成新热梗，这条二创被连续搬运整整一周",
  "【现场】小城夜市排队原始长龙被无人机视角完整记录",
  "【追踪】选手后台互剪彩排花絮流出，导演组本子细节待核实",
  "【快讯】便利店夜班监控还原暖心一幕，当事人隔日转发认领",
  "【一线】演唱会应援墙前的温情一幕冲上本日好感榜",
];

export const stats = [
  { value: "今日新料", num: "128", unit: "条" },
  { value: "追踪事件", num: "46", unit: "起" },
  { value: "一手实拍", num: "12k", unit: "段" },
  { value: "目击投稿", num: "860", unit: "份" },
];

export const hotList: HotItem[] = [
  { rank: 1, title: "唱跳新综首期路透名场面连上热搜", category: "综艺现场", heat: 98, tag: "一手实拍", live: true },
  { rank: 2, title: "测评博主直播翻车后临场补救被夸清醒", category: "直播名场面", heat: 92, tag: "原发经过", live: true },
  { rank: 3, title: "雨夜片场场务暖贴分发一幕持续发酵", category: "圈内动态", heat: 87, tag: "目击细节", live: false },
  { rank: 4, title: "反转一词二创搬运一周热度不减", category: "网络热梗", heat: 81, tag: "持续回刷", live: false },
  { rank: 5, title: "无人机视角记录小城夜市原始排队", category: "生活奇闻", heat: 76, tag: "现场实拍", live: false },
  { rank: 6, title: "选手后台互剪彩排花絮待多方核实", category: "圈内动态", heat: 69, tag: "待核实", live: false },
];

export const feedItems: FeedItem[] = [
  {
    id: 1,
    category: "variety",
    title: "唱跳新综首期开录：观众席一小时连出三组名场面",
    snippet: "吃瓜前线蹲守第一现场，路透显示首期录制中先后出现摔倒救场、互怼出梗、导师即兴示范三组高能瞬间，一手实拍完整还原全场反应。",
    tags: ["一手实拍", "目击细节"],
    time: "12分钟前",
    views: "48.2w",
    featured: true,
    image: "https://readdy.ai/api/search-image?query=Warm%20editorial%20photo%20of%20a%20vibrant%20Chinese%20variety%20show%20studio%20stage%20with%20colorful%20neon%20stage%20lights%2C%20live%20audience%20seats%20in%20foreground%2C%20candid%20backstage%20energy%2C%20film%20grain%2C%20cinematic%20composition%2C%20soft%20warm%20tones%2C%20documentary%20news%20style&width=960&height=640&seq=feed-var01&orientation=landscape",
    alt: "综艺节目录制现场观众席实拍一手画面",
  },
  {
    id: 2,
    category: "live",
    title: "百万粉测评博主直播翻车全程：锅气烟雾与临场补救",
    snippet: "原发直播片段显示测评中途烤炉起火冒烟，博主一边致歉一边就地拆机排查，观众留言一致认可其清醒处置，事件被完整回放复盘。",
    tags: ["原发经过", "直播直击"],
    time: "26分钟前",
    views: "36.7w",
    image: "https://readdy.ai/api/search-image?query=Cozy%20live%20streaming%20studio%20table%20with%20grill%20and%20light%20steam%20rising%2C%20ring%20light%20and%20camera%20setup%2C%20warm%20indoor%20lighting%2C%20hands-on%20tech%20review%20scene%2C%20candid%20real%20moment%2C%20soft%20warm%20tones%2C%20editorial%20documentary%20style&width=800&height=600&seq=feed-live02&orientation=landscape",
    alt: "测评直播间翻车现场原发直播画面",
  },
  {
    id: 3,
    category: "showbiz",
    title: "雨夜片场实拍：场务小姐姐分发暖贴一幕登本日点赞榜",
    snippet: "剧组夜拍被路人围观，镜头里场务姑娘冒雨为群演逐一发放暖贴，现场目击细节被转发后登上本日好感榜，导演组隔日发声致谢。",
    tags: ["目击细节", "现场实拍"],
    time: "41分钟前",
    views: "29.3w",
    image: "https://readdy.ai/api/search-image?query=Night%20film%20set%20scene%20in%20light%20rain%20with%20crew%20members%20holding%20warm%20patches%2C%20warm%20practical%20lights%20and%20bokeh%2C%20rainy%20glow%2C%20behind%20the%20scenes%20documentary%20moment%2C%20soft%20warm%20tones%2C%20cinematic%20and%20heartwarming&width=800&height=600&seq=feed-show03&orientation=landscape",
    alt: "雨夜片场场务人员分发暖贴的现场目击画面",
  },
  {
    id: 4,
    category: "meme",
    title: "“反转”成为新热梗：这条二创被搬运了整整一周",
    snippet: "一条套用反转叙事拍出的搞笑二创持续破圈，版本多到数不清，吃瓜前线为你整理原版与高赞二创的事件链，方便随时回刷。",
    tags: ["网络热梗", "持续回刷"],
    time: "1小时前",
    views: "52.1w",
    image: "https://readdy.ai/api/search-image?query=Playful%20meme%20collage%20aesthetic%20with%20sticker%20style%20elements%20and%20turning%20arrows%2C%20vibrant%20warm%20orange%20and%20yellow%20palette%2C%20social%20media%20trending%20graphic%2C%20bold%20fun%20energy%2C%20flat%20illustration%2C%20trendy%20internet%20culture&width=800&height=600&seq=feed-meme04&orientation=landscape",
    alt: "反转网络热梗二创合集封面图",
  },
  {
    id: 5,
    category: "variety",
    title: "演唱会应援墙前的温情一幕登上本日好感榜",
    snippet: "演出散场后粉丝自发在应援墙前整理留言卡片，现场实拍视角记录下这幕相互托举的温柔瞬间，主办方随后晒出墙体完整展示。",
    tags: ["现场实拍", "目击细节"],
    time: "1小时前",
    views: "21.8w",
    image: "https://readdy.ai/api/search-image?query=Fans%20around%20a%20glowing%20support%20message%20wall%20after%20a%20concert%2C%20warm%20string%20lights%20and%20paper%20notes%2C%20gentle%20evening%20atmosphere%2C%20touching%20moment%2C%20soft%20golden%20tones%2C%20cinematic%20documentary%20photography&width=800&height=600&seq=feed-var05&orientation=landscape",
    alt: "演唱会应援墙前温情一幕的现场实拍",
  },
  {
    id: 6,
    category: "life",
    title: "无人机视角完整记录小城夜市排队的原始长龙",
    snippet: "吃瓜前线实拍直击：夜宵档开摊半小时，无人机镜头完整还原食客从街头排到街尾的原始长龙，摊主隔日回应加量备货。",
    tags: ["现场实拍", "原发经过"],
    time: "2小时前",
    views: "18.4w",
    image: "https://readdy.ai/api/search-image?query=Aerial%20drone%20view%20of%20a%20long%20evening%20night%20market%20queue%20winding%20through%20warm%20street%20food%20stall%20lights%2C%20night%20city%20scene%2C%20candid%20documentary%20aerial%20shot%2C%20warm%20amber%20glow%2C%20bustling%20atmosphere&width=800&height=600&seq=feed-life06&orientation=landscape",
    alt: "无人机视角记录夜市排队现场的实拍画面",
  },
  {
    id: 7,
    category: "showbiz",
    title: "选手后台互剪彩排花絮流出：导演组手把手改本细节",
    snippet: "一段后台互剪彩排的花絮被放出，镜头里选手与导演逐句打磨台本，现场目击细节丰富，部分内容尚待多方核实后归档。",
    tags: ["待核实", "圈内动态"],
    time: "3小时前",
    views: "14.9w",
    image: "https://readdy.ai/api/search-image?query=Backstage%20rehearsal%20room%20with%20artists%20and%20director%20reviewing%20a%20script%20together%2C%20monitor%20screens%20and%20soft%20studio%20lights%2C%20candid%20working%20moment%2C%20documentary%20style%2C%20warm%20neutral%20tones&width=800&height=600&seq=feed-show07&orientation=landscape",
    alt: "选手后台互剪彩排花絮的现场目击画面",
  },
  {
    id: 8,
    category: "life",
    title: "便利店夜班监控还原暖心一幕：当事人隔日转发认领",
    snippet: "吃瓜前线直击：夜班店员在监控下救下一只躲雨的流浪猫，原画被好心顾客发上网，隔日当事人本人转发认领，事件链就此闭环。",
    tags: ["原发经过", "暖心直击"],
    time: "4小时前",
    views: "31.2w",
    image: "https://readdy.ai/api/search-image?query=Night%20convenience%20store%20interior%20view%20from%20a%20security%20camera%20angle%20with%20a%20staff%20member%20gently%20rescuing%20a%20small%20sheltered%20cat%20near%20the%20doorway%2C%20fluorescent%20warm%20light%2C%20documentary%20surveillance%20style%2C%20heartwarming%20candid%20moment&width=800&height=600&seq=feed-life08&orientation=landscape",
    alt: "便利店夜班监控还原救助流浪猫的现场画面",
  },
];

export const chain = {
  tag: "完整事件链",
  title: "唱跳新综首期路透：一场名场面如何从碎片拼成闭环",
  intro:
    "吃瓜前线蹲守第一现场，用原始时间线把散落各处的路透、实拍与回应串成完整事件链，让你一次看清单条热点从出现到定论的全程。",
  stages: [
    { stage: "初现", title: "首期录制开启，现场路透开始流出", desc: "节目组官宣开机后，首批场外照片与短片段在多个社群被上传，信息处于零散阶段。", time: "Day 1 · 09:40", state: "已归档" },
    { stage: "发酵", title: "观众席实拍被大量搬运", desc: "三段观众席实拍被接连转发，摔倒救场、互怼出梗等名场面被快速提炼成看点，热度爬升。", time: "Day 1 · 15:10", state: "进行中" },
    { stage: "回应", title: "节目组与嘉宾先后发声", desc: "节目组发长文感谢现场秩序，当事嘉宾在社交动态补充台前幕后细节，多方口径逐渐对齐。", time: "Day 2 · 11:00", state: "进行中" },
    { stage: "核实", title: "工作人员补充一手细节", desc: "吃瓜前线联系到现场工作人员，补充救场细节与剪辑逻辑，对网传部分说法做了标注澄清。", time: "Day 2 · 20:30", state: "已核实" },
    { stage: "定论", title: "官方预告上线，事件链完整归档", desc: "节目组释出正式预告，与本台整理的完整时间线相互印证，该条事件链归档可随时回刷。", time: "Day 3 · 12:00", state: "已归档" },
  ],
};

export const faqs: Faq[] = [
  { q: "吃瓜前线是什么？", a: "吃瓜前线是一个聚焦热点事件前线的内容聚合平台，强调一手实拍、目击细节与原发经过，尽量避免二手转述带来的信息失真。" },
  { q: "为什么叫吃瓜前线？", a: "吃瓜指围观热点事件，前线指事件发生的第一现场。我们把自己定位成蹲守在事件最前沿的围观位，第一时间呈现现场细节。" },
  { q: "内容多久更新一次？", a: "热点事件发生后我们会在最快时间内整理并上线现场内容，首页会持续回刷更新，出现新的进展会第一时间补充到事件链中。" },
  { q: "如何向吃瓜前线投稿或爆料？", a: "你可以在首页顶部的我要爆料入口留下线索，或通过页脚的联系邮箱发送现场素材，我们会在核实信息与现场情况后择优采用。" },
  { q: "这里的现场内容是否可靠？", a: "吃瓜前线优先采用当事现场的一手实拍与目击描述，并标注信息所处阶段与待核实内容，供读者理性参考、交叉印证。" },
];

export const features: FeatureCard[] = [
  { icon: "ri-camera-lens-fill", title: "一手实拍", desc: "尽量采用当事现场的原始影像与画面，还原真实发生的每一刻。" },
  { icon: "ri-eye-2-fill", title: "目击细节", desc: "不满足于标题，把容易被忽略的细节与前后文一起交代清楚。" },
  { icon: "ri-file-list-3-fill", title: "原发经过", desc: "按时间先后梳理来龙去脉，把散落信息拼回完整事件链。" },
  { icon: "ri-refresh-fill", title: "持续回刷", desc: "事件有新进展就第一时间补充归档，随时回刷都有新爆点。" },
];

export const feedbacks = [
  { name: "一位综艺观众", text: "蹲了一下午，前线更新比路人转述快多了，名场面一个没落下。" },
  { name: "常回刷的老粉", text: "最喜欢看完整事件链，哪条瓜从哪开始到哪结束一目了然。" },
  { name: "现场投稿人", text: "投稿之后有编辑找我核实细节，处理得很认真，不怕被断章取义。" },
];